module.exports = __webpack_public_path__ + "static/media/konosuba-lg2.e0b266b0.jpg";